// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSessionDocAssemble,
  getAnswerDocAssemble,
  GetCaveatICASearchResult,
  getCountries,
} from "@api";
import { showLoader } from "../../globalstore";
export const getSession = createAsyncThunk(
  "applicationform/getSession",
  async (args) => {
    const response = await getSessionDocAssemble({ interviewName: args });
    return response.data;
  }
);

export const GetCaveatICAResult = createAsyncThunk(
  "applicationform/caveat_ica_result",
  async (args) => {
    const response = await GetCaveatICASearchResult();
    return response.data;
  }
);

export const getAnswer = createAsyncThunk(
  "applicationform/getAnswer",
  async (args) => {
    const response = await getAnswerDocAssemble({ session: args });
    return response.data;
  }
);

export const GetCountries = createAsyncThunk(
  "common/countries",
  async (args) => {
    const response = await getCountries(args);
    return response.data;
  }
);

export const applicationFormSlice = createSlice({
  name: "applicationform",
  initialState: {
    session: "",

    ICA_data_exist: null,
    ICA_data_true: null,
    Deceased_Name: "",
    Deceased_Id: "",
    Deceased_Gender: "",
    Deceased_Death_Cert: "",
    Deceased_Nationality: "",
    Deceased_DateOfDeath: "",
    Deceased_Death_Place: "",
    Last_Known_Address_IsSG: false,
    Deceased_Address_Overseas: "",
    Deceased_Address_Block_Overseas: "",
    Deceased_Address_Postal: "",
    Deceased_Address_Block: "",
    Deceased_Address_Floor: "",
    Deceased_Address_Unit: "",
    Deceased_Address_Street: "",
    Deceased_Address_Building: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSession.fulfilled, (state, action) => {
        state.session = action.payload;
      })
      // .addCase(GetCountries.fulfilled, (state, action) => {

      //   state.countries = action.payload.amr;
      // })
      .addCase(GetCaveatICAResult.fulfilled, (state, action) => {
        state.ICA_data_exist =
          typeof action.payload.isDataCorrect === "boolean";
        state.ICA_data_true = action.payload.isDataCorrect;
        state.Deceased_Name = action.payload.principalName;
        state.Deceased_Id = action.payload.deathIdNo;
        state.Deceased_Gender = action.payload.deathGender;
        state.Deceased_Death_Cert = action.payload.deathRegNo;
        state.Deceased_Nationality = action.payload.nationality;
        state.Deceased_DateOfDeath = action.payload.deathDate;
        state.Deceased_Death_Place = action.payload.deathAddr;

        // if the addresstype is C means that it is an overseas address
        state.Last_Known_Address_IsSG =
          typeof action.payload.addressType === "string" &&
          action.payload.addressType !== "C";

        state.Deceased_Address_Postal = action.payload.addressPostalCode;
        state.Deceased_Address_Block = action.payload.addressBlockHouseNo;
        state.Deceased_Address_Floor = action.payload.addressFloorNo;
        state.Deceased_Address_Unit = action.payload.addressUnitNo;
        state.Deceased_Address_Street = action.payload.addressStreetName;
        state.Deceased_Address_Building = action.payload.addressBuldingName;
        state.Deceased_Address_Overseas =
          (action.payload.addressBlockHouseNo == null
            ? ""
            : action.payload.addressBlockHouseNo) +
          (action.payload.addressStreetName == null
            ? ""
            : " " + action.payload.addressStreetName) +
          (action.payload.addressFloorNo == null
            ? ""
            : " " + action.payload.addressFloorNo + "-") +
          (action.payload.addressUnitNo == null
            ? ""
            : " " + action.payload.addressUnitNo) +
          (action.payload.addrBldgName == null
            ? ""
            : " " + action.payload.addrBldgName);
        state.Deceased_Address_Block_Overseas =
          action.payload.addressBlockHouseNo;

        if (
          action.payload.erroMessage &&
          action.payload.erroMessage.includes(
            "information from ICA is incomplete"
          )
        ) {
          state.ICA_data_exist = true; // cater with DocAssemble logics
        }
      });
  },
});

//export const {} = eligibilityCheckSlice.actions

export default applicationFormSlice.reducer;
